import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 276px;
  margin: 16px;
  padding: 16px;
  gap: 16px;
  border-radius: 8px;
  background-color: #fff;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
`;
